// src/components/InfluencerList.js

import React, { useState, useEffect } from 'react';
import {
  Box, Heading, Text, Spinner, Container, SimpleGrid, Card, CardBody, VStack, Button, Link, Icon,
} from '@chakra-ui/react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import axios from 'axios';

const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app';

const InfluencerList = () => {
  const [influencers, setInfluencers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchInfluencers = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/public/influencers`);
        setInfluencers(response.data);
      } catch (error) {
        console.error('Error fetching influencers:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInfluencers();
  }, []);

  if (isLoading) {
    return <VStack justify="center" align="center" h="50vh"><Spinner size="xl" /></VStack>;
  }

  return (
    <Container maxW="container.xl" py={12}>
      <Heading as="h1" size="xl" mb={10} textAlign="center">
        Community Influencers
      </Heading>
      {influencers.length === 0 ? (
        <Text textAlign="center" fontSize="lg" color="gray.500">
            No influencer profiles found.
        </Text>
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {influencers.map((influencer) => (
            <Card key={influencer.id} borderWidth="1px" borderRadius="lg" boxShadow="md" textAlign="center">
              <CardBody>
                <VStack spacing={4}>
                  <Heading as="h3" size="lg">{influencer.influencer_name}</Heading>
                  <Button
                    as={Link}
                    href={influencer.social_media_link}
                    isExternal
                    colorScheme="pink"
                    rightIcon={<Icon as={FaExternalLinkAlt} />}
                  >
                    View Profile
                  </Button>
                </VStack>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      )}
    </Container>
  );
};

export default InfluencerList;